<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-sheet class="card-rounded">
        <v-row no-gutters>
          <v-col cols="12" class="pa-4">
            <v-row
              no-gutters
              justify="space-between"
              class="mb-3"
              align="center"
            >
              <span class="header-text">{{ $t('message.adminPage.payment.paymentSlip') }}</span>
            </v-row>
          </v-col>
          <v-col cols="12" class="px-4">
            <v-row
              no-gutters
              v-for="(paymentEvidence, i) in paymentEvidencesData"
              :key="i"
            >
              <v-col cols="6" class="mb-3">
                <v-row no-gutters
                  ><span class="caption-text">{{ $t('message.adminPage.payment.date') }}</span></v-row
                >
                <v-row no-gutters
                  ><span class="default-text">{{
                    paymentEvidence?.txn_date == null ? "-" : formatDate(paymentEvidence?.txn_date)
                  }}</span></v-row
                >
              </v-col>
              <v-col cols="6" class="mb-3">
                <v-row no-gutters><span class="caption-text">{{ $t('message.adminPage.payment.time') }}</span></v-row>
                <v-row no-gutters
                  ><span class="default-text">{{
                    paymentEvidence?.txn_date == null ? "-" : formatTime(paymentEvidence?.txn_date) + " " + $t('message.formSummit.time')
                  }}</span></v-row
                >
              </v-col>
              <v-col cols="6" class="mb-3">
                <v-row no-gutters
                  ><span class="caption-text">{{ $t('message.adminPage.payment.amount') }}</span></v-row
                >
                <v-row no-gutters
                  ><span class="default-text">{{
                    paymentEvidence?.txn_date == null ?  "-" : paymentEvidence?.payment_amount + " " + $t('message.common.currency.baht')
                  }} </span></v-row
                >
              </v-col>
              <v-col cols="6" class="mb-3">
                <v-row no-gutters
                  ><span class="caption-text">{{ $t('message.adminPage.payment.transactionID') }}</span></v-row
                >
                <v-row no-gutters
                  ><span class="default-text"
                    >{{paymentEvidence?.txn_date == null || paymentEvidence?.transaction_number == null ? "-" : paymentEvidence?.transaction_number }}
                  </span>
                  <v-btn icon small color="primary" @click="copyToClipboard(paymentEvidence?.transaction_number)">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>

            <DragDropUploader
              v-if="applicant?.id"
              :is_payment_evidence="true"
              :student_id="applicantInfo?.id"
              :filesProp="applicantInfo?.files"
              @showAlert="showAlert"
              @onDeleteFile="onDeleteFile"
              @onUploadPayment="onUploadPayment"
              @loadingUpdate="loadingUpdate"
            ></DragDropUploader>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import DragDropUploader from "@/components/admin/Candidates/Applicant/DragDropFiles/DragDropUploader.vue";
import { dateTimeLocale, formatDateTimeLocale, formatTime } from '@/utils/date';
import i18n from '@/i18n';
export default {
  props: {
    applicantInfo: Object,
    paymentEvidencesInfo: Array,
    currentStep: String,
  },
  components: {
    DragDropUploader,
  },
  mounted() {
    this.retrievedData();
  },

  data() {
    return {
      applicant: {},
      paymentEvidences: [],
      isUploadFileActive: false,
    };
  },
  computed: {
    locale(){
      return i18n.locale;
    },
    paymentEvidencesData(){
      let output = []
      if(this.paymentEvidences.length == 0){
        output.push({
          created_at: dateTimeLocale("YYYY-MM-DD HH:mm:ss", this.locale),
          updated_at: dateTimeLocale("YYYY-MM-DD HH:mm:ss", this.locale),
          document_name: "-",
          expire_date: "-",
          file_id: "-",
          id: "-",
          is_student_upload: false,
          payment_amount: "-",
          payment_evidence: "-",
          student: {
            id: this.applicant.id
          },
          transaction_number: "-",
          txn_date: null,
        })
        return output
      }
      else{
        const student_upload = this.paymentEvidences.find((item) => item.is_student_upload == true)
        if(student_upload){
          output.push(student_upload)
        }
        else{
          if(this.paymentEvidences.length > 0){
            output.push(this.paymentEvidences[0])
          }
        }
        if(output.length !=  0){
          return output
        }
        else{
          output.push(this.paymentEvidences[0])
          return output
        }
      }
      
    }
  },
  methods: {
    loadingUpdate(value) {
      this.$emit("loadingUpdate", value);
    },
    showAlert(status, text) {
      this.$emit("showAlert", status, text);
    },
    retrievedData() {
      let paymentEvidences = JSON.parse(
        JSON.stringify(this.paymentEvidencesInfo)
      );
      let applicant = JSON.parse(JSON.stringify(this.applicantInfo));

      this.applicant = applicant;
      this.paymentEvidences = paymentEvidences;
    },
    formatDate(datetime){
      let newDate
      if(isNaN(datetime)){
        newDate = Date.parse(datetime);
      }
      else{
        newDate = new Date(Number(datetime));
      }
      if (newDate) return formatDateTimeLocale(newDate, this.locale);
      else return "";
    },
    formatTime(datetime){
      let newDate
      if(isNaN(datetime)){
        newDate = Date.parse(datetime);
      }
      else{
        newDate = new Date(Number(datetime));
      }
      if (newDate) return formatTime(newDate,'','');
      else return "";
    },
    onDeleteFile(fileName){
      this.paymentEvidences = this.paymentEvidences.filter((item) => item.document_name != fileName)
      this.$emit("updateEvidenceFile", this.paymentEvidences)
    },
    onUploadPayment(body){
      body.payment_amount = this.applicant?.register_form?.fee || 0
      this.paymentEvidences.push(body)
      this.$emit("updateEvidenceFile", this.paymentEvidences)
    },
    copyToClipboard(transaction) {
      if(transaction == null){
        transaction = ""
      }
      navigator.clipboard.writeText(
        `${transaction}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
.file-input-class {
  position: relative;
}
.drag-drop-active {
  opacity: 100;
  position: relative;
  transition: all;
}
.drag-drop-hidden {
  opacity: 0;
  position: absolute;
  transition: all;
}
.relative-container {
  position: relative;
}
.action-text {
  color: #afadb1;

  font-weight: 400;
  font-family: "Sarabun";
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
}
.action-text-btn {
  color: #ff9800;
  text-decoration: underline;
  font-weight: 500;
  font-family: "Prompt";
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
}
.upload-files-drag-drop-container {
  /* Dark/Nav 50 - FAFAFD */

  background: #fafafd;
  /* Neutrals/D4D9DE */

  border: 2px dashed #d4d9de;
  border-radius: 10px;
}
.file-card-rounded {
  background: #fafafd;
  border-radius: 10px;
}
.underline-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  text-decoration-line: underline;

  /* Primary/Primary 500 - FF9800 */

  /* color: #ff9800; */
}
.header-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #255d98;
}
.caption-text {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #9d9b9a;
}
.default-text-14 {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #37323c;
}
.default-text-14-white {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
}
.default-text {
  font-family: "Sarabun";
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
  border-radius: 10px 10px 10px 10px;
}
</style>
